import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function TellMeWhenPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new waitlist page
    navigate('/waitlist', { replace: true });
  }, [navigate]);

  // Show a brief loading state while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
    </div>
  );
}